import React from 'react'
// components
import Modal from 'components/UI/Modal'
import Header from 'components/UI/Modal/Header'
import { Content } from 'themes/views/modals'
import CredentialsView from './CredentialsView'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/modals'
// types
import { IApiClientCreatedCredentials } from 'types/graphql'

interface ModalData {
  isOpen: boolean
  credentials?: IApiClientCreatedCredentials
}

const ApiClientSecretModal: React.FC = () => {
  const {
    hideModal,
    updateModal,
    modalData: { isOpen, credentials }
  } = useModalData<ModalData>({ modalType: Modals.API_CLIENT_SECRET_MODAL })

  if (!isOpen || !credentials) {
    return null
  }

  // Drop the one-time secret from Redux state once the user is done with it.
  const handleDone = () => {
    hideModal()
    updateModal({ credentials: null })
  }

  return (
    <Modal isOpen={isOpen} width='sm' disableBackdropClick disableEscapeKeyDown>
      <Header>API Client Created</Header>
      <Content>
        <CredentialsView credentials={credentials} onDone={handleDone} />
      </Content>
    </Modal>
  )
}

export default ApiClientSecretModal
